import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'



NProgress.configure({ showSpinner: false })// NProgress 页面导航

// 验证是否有权限
// function hasPermission(roles, permissionRoles) {
//   if (roles.indexOf('admin') >= 0) return true // admin permission passed directly
//   if (!permissionRoles) return true
//   return roles.some(role => permissionRoles.indexOf(role) >= 0)
// }

const whiteList = ['/login'] // 白名单
router.beforeEach((to, from, next) => {
  NProgress.start() // 开启进度条
  const routerdata = sessionStorage.getItem('roles')? sessionStorage.getItem('roles'):[];
   // 设置页面标题
  document.title = getPageTitle(to.meta.title)
  if (getToken() && routerdata.length>0) { //验证是否有token
    /* has token*/
    if (to.path === '/login') {  // 如果是进入登录页面 则不需要权限 直接进入
      next({ path: '/' })
      NProgress.done() // 页面导航结束
    } else {

      console.log('跳转',to)


    //   if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
    //     store.dispatch('user/GetInfo').then(res => { // 拉取user_info
    //       store.dispatch('GenerateRoutes', res).then(() => { // 根据roles权限生成可访问的路由表

    //         router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
    //         next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
    //       })
    //     }).catch((err) => {
    //       store.dispatch('FedLogOut').then(() => {
    //         Message.error(err || 'Verification failed, please login again')
    //         next({ path: '/' })
    //       })
    //     })
    //   } else {
        next()
        // // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
        // if (hasPermission(store.getters.perms, to.meta.perms)) {
        //   next()
        // } else {
        //   next({ path: '/401', replace: true, query: { noGoBack: true } })
        // }
        // 可删 ↑
    //   }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})

















// NProgress.configure({ showSpinner: false }) // NProgress Configuration

// // 白名单
// const whiteList = ['/'] // no redirect whitelist
// // 路由拦截
// router.beforeEach(async(to, from, next) => {
//   // 进度条开始
//   NProgress.start()

//   // 设置页面标题
//   document.title = getPageTitle(to.meta.title)

//   // 确定用户是否已经登录
//   const hassToken = getToken()

//   if (hasToken) {
//     if (to.path === '/login') {
//       // 如果登录重定向 主页
//       next({ path: '/' })
//       NProgress.done()
//     } else {
//       const hasGetUserInfo = store.getters.name
//       if (hasGetUserInfo) {
//         next()
//       } else {
//         try {
//           // 获取用户信息
//           await store.dispatch('user/getInfo')

//           next()
//         } catch (error) {
//           // 删除 token 重新进入 登录页面
//           await store.dispatch('user/resetToken')
//           Message.error(error || 'Has Error')
//           next(`/login?redirect=${to.path}`)
//           NProgress.done()
//         }
//       }
//     }
//   } else {
//     /*
//         没有token
//     */

//     if (whiteList.indexOf(to.path) !== -1) {
//       // 在免白名单里面直接 访问
//       next()
//     } else {
//       //其他没有访问权限的页面被重定向到登录页面。
//       next(`/login?redirect=${to.path}`)
//       NProgress.done()
//     }
//   }
// })

// router.afterEach(() => {
//   // finish progress bar
//   NProgress.done()
// })